export type DriverPlanningInputLine = {
  driverIdNumber: string;
  startDate: string;
  startTime: string;
  endTime: string;
  expectedMileage: string;
  driverCity?: string;
  clientName?: string;
  clientFirstName?: string;
  clientCity?: string;
  activityType?: string;
};

type DriverPlanningColumn = keyof DriverPlanningInputLine;

//FIRST ACCEPTED HEADER IS THE ONE DISPLAYED IN THE ERRORS OF MISSING HEADERS
export const driverPlanningHeaderColumns = [
  {
    field: "driverIdNumber",
    acceptedHeaders: ["Code salarié"],
    required: true,
  },
  {
    field: "startDate",
    acceptedHeaders: ["Date début intervention", "Date début"],
    required: true,
  },
  {
    field: "startTime",
    acceptedHeaders: ["Heure début intervention", "Heure début"],
    required: true,
  },
  {
    field: "endTime",
    acceptedHeaders: ["Heure fin intervention", "Heure fin"],
    required: true,
  },
  {
    field: "expectedMileage",
    acceptedHeaders: ["Kilomètres"],
    required: true,
  },
  {
    field: "driverCity",
    acceptedHeaders: ["Commune Conducteur", "Commune"],
  },
  {
    field: "clientName",
    acceptedHeaders: ["Nom Client", "Nom usuel du membre"],
  },
  {
    field: "clientFirstName",
    acceptedHeaders: ["Prénom Client", "Prénom"],
  },
  {
    field: "clientCity",
    acceptedHeaders: ["Commune Client", "Commune_1"],
  },
  {
    field: "activityType",
    acceptedHeaders: ["Type d'activité", "Nom Rubrique"],
  },
] as const satisfies readonly {
  field: DriverPlanningColumn;
  acceptedHeaders: string[];
  required?: boolean;
}[];

export const requiredDriverPlanningColumns = driverPlanningHeaderColumns
  .filter((column) => "required" in column && column.required)
  .map((column) => column.field);
